import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ColoringState } from '../../types';
import {PersistentManager} from "../../utils/PersistentManager";
// We can't import the store here as it would create a circular dependency
// The store imports this file, so we can't import the store here

const COLOR_STORAGE_KEY = 'coloring_last_color';
const MAX_HISTORY_SIZE = 10; // Default maximum history size

const initialState: ColoringState = {
  currentColor: '#ff0000', // Default color until async load completes
  history: [{ coloredRegions: {} }], // Always start with an empty state in history
  currentStep: 0,
};

// We'll initialize the color in the component that uses it instead

const coloringSlice = createSlice({
  name: 'coloring',
  initialState,
  reducers: {
    setColor: (state, action: PayloadAction<string>) => {
      state.currentColor = action.payload;
      // Save color to localStorage whenever it changes
      PersistentManager.getInstance().setItem(COLOR_STORAGE_KEY, action.payload);
    },
    addToHistory: (state, action: PayloadAction<{ coloredRegions: { [key: string]: string } }>) => {
      // Remove any future steps if we're not at the end
      if (state.currentStep < state.history.length - 1) {
        state.history = state.history.slice(0, state.currentStep + 1);
      }
      // Add new history entry
      state.history.push(action.payload);
      // Limit history size
      if (state.history.length > MAX_HISTORY_SIZE) {
        state.history.shift(); // Remove the oldest entry
      }
      state.currentStep = state.history.length - 1;
    },
    undo: (state) => {
      console.log('Undo action dispatched, current step:', state.currentStep, 'history length:', state.history.length);
      if (state.currentStep > 0) {
        state.currentStep--;
        console.log('After undo, new step:', state.currentStep);
      }
    },
    redo: (state) => {
      console.log('Redo action dispatched, current step:', state.currentStep, 'history length:', state.history.length);
      if (state.currentStep < state.history.length - 1) {
        state.currentStep++;
        console.log('After redo, new step:', state.currentStep);
      }
    },
    reset: (state) => {
      console.log('Reset action dispatched');
      state.history = [{ coloredRegions: {} }];
      state.currentStep = 0;
    },
    setHistory: (state, action: PayloadAction<{ history: { coloredRegions: { [key: string]: string } }[], currentStep: number }>) => {
      // Ensure we always have at least one history entry
      if (action.payload.history.length === 0) {
        state.history = [{ coloredRegions: {} }];
        state.currentStep = 0;
      } else {
        state.history = action.payload.history;
        state.currentStep = action.payload.currentStep;
      }
    },
  },
});

export const { setColor, addToHistory, undo, redo, reset, setHistory } = coloringSlice.actions;
export default coloringSlice.reducer; 